import { useRef } from 'react';
import { Provider } from 'react-redux';

// Setup interceptors right after store is initialized and before any requests
// because interceptors will dispatch `logout` action in case of token refresh failure
import 'src/agent/api/apiClient/setup-interceptors';
import { makeStore } from 'src/store';

interface ReduxProviderProps {
  children: React.ReactNode;
}

export const ReduxProvider = ({ children }: ReduxProviderProps) => {
  const storeRef = useRef<ReturnType<typeof makeStore>>(undefined);

  if (!storeRef.current) {
    storeRef.current = makeStore();
  }

  return <Provider store={storeRef.current}>{children}</Provider>;
};
